import serverApi from "../utils/serverApi";

const attestationReportsService = {
  getAttestationResports: (isLoading = false) => serverApi({ uri: "attestation-resports", method: "GET", isLoading: isLoading }),
};

export default attestationReportsService;
